import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showSearchTooltip: false,
};

export const dashboardInterfaceSlice = createSlice({
  name: 'dashboardInterface',
  initialState,
  reducers: {
    setShowSearchTooltip: (state, { payload }) => ({
      ...state,
      showSearchTooltip: payload,
    }),
  },
});

export default dashboardInterfaceSlice.reducer;
